import {
  ACTIVE,
  AUTHORIZING,
  BANNED,
  DEFAULT_ERROR_MESSAGE,
  DELETED,
  ERROR,
  INITIALIZED,
  READY,
} from '@app/constants';

export interface IntegrationStatusView {
  label: string;
  hint: string;
}

const getErrorHint = (errorMessage: string | null): string => {
  if (!errorMessage) {
    return DEFAULT_ERROR_MESSAGE;
  }

  if (errorMessage.includes('ServiceUnavailable')) {
    return 'Поставщик АТС проводит технические работы';
  }

  return errorMessage;
};

// Один словарь состояний интеграции на весь продукт: реестр интеграций и
// вкладка «Интеграции» в карточках пользователя/исполнителя показывают одни
// и те же слова с одними подсказками (us/10721, task/10727; словарь введён
// в task/10728).
export const getIntegrationStatusView = (
  status: string | null,
  errorMessage: string | null
): IntegrationStatusView => {
  switch (status) {
    case ACTIVE:
      return {
        label: 'Работает',
        hint: 'Интеграция подключена, сообщения проходят',
      };
    case READY:
      return {
        label: 'Готова к работе',
        hint: 'Канал настроен и ждёт первых сообщений',
      };
    case AUTHORIZING:
      return {
        label: 'Подключается',
        hint: 'Идёт вход в аккаунт. Если состояние не меняется, откройте настройку интеграции',
      };
    case INITIALIZED:
      return {
        label: 'Не подключена',
        hint: 'Канал создан, но вход в аккаунт не выполнен — откройте настройку интеграции',
      };
    case BANNED:
      return {
        label: 'Заблокирована',
        hint: 'Аккаунт заблокирован на стороне мессенджера',
      };
    case DELETED:
      return {
        label: 'В архиве',
        hint: 'Интеграция удалена и больше не используется',
      };
    case ERROR:
      return { label: 'Ошибка', hint: getErrorHint(errorMessage) };
    default:
      return {
        label: 'Нет данных',
        hint: 'Сервис не сообщил состояние интеграции',
      };
  }
};

/**
 * Подстатус входа: канал работает, но провайдер ждёт действия человека.
 * Один словарь на реестр интеграций и баннер «Сбои интеграций» — раньше у
 * баннера был свой, и в нём подпись challenge_required не показывалась из-за
 * опечатки в условии (issue/11031).
 */
export const getIntegrationSubStatusText = (
  subStatus: string | null
): string => {
  switch (subStatus) {
    case 'challenge_required':
      return 'Необходимо действие в приложении';
    case 'totp_required':
      return 'Необходимо пройти двухфакторную авторизацию';
    case 'password_required':
      return 'Необходимо ввести пароль';
    default:
      return '';
  }
};
